import React from "react";
//import axios from 'axios';
//import AuthService from '../Services/auth.service';
//import Moment from 'react-moment';
//import moment from 'moment';
import Breadcrumb from '../Components/Breadcrumb';
//import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './Wallettrans.css';
class Wallettrans extends React.Component {
    constructor(props){
        super(props);
            this.state = {
               walt:[],Mmonth:''
            }
           
        }



        /*componentDidMount(){
            const dateObj = new Date()
            const monthName = dateObj.toLocaleString("default", { month: "2-digit" })
            this.setState({current:monthName})
           // this.setState({current:monthName})
            this.getData(monthName)
          }*/

          /*getData(Month){
            const USR_TOKEN = localStorage.getItem("userToken")
            if(USR_TOKEN){
               //alert(USR_TOKEN)
                const user =  AuthService.getCurrentUser();
                this.setState({profile:user})
        axios.get(process.env.REACT_APP_API_URL + 'api/method/prettypets.api.wallet_transactions?month='+Month,{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({walt:response.data['message']})
            console.log(response.data['message'])
        })
    }
    else{
        alert("Not Logged in")
    }
}*/
/*handleChange(event) 
        {
           //this.setState({Mmonth: event.target.value});
           this.setState({ismonth:true});
           this.setState({current:''})
           //althisert(.state.Mmonth)
           //  alert(event.target.value)
           this.setState({Mmonth:event.target.value})
           this.getData(event.target.value)
           //event.preventDefault();
         }*/
  render() {
    return <div>
<div className="container mt-4 pt-4">
<Breadcrumb head="My Wallet"/>

    <div className="row">
        <div className="col-md-4">
            <h2><a href="/my-wallet" type="button">{/*<ArrowBackIcon className="mr-2"/>*/}</a>Wallet</h2>
        </div>
        <div className=" col-md-4 ">
        <p className="manage">You can manage your past orders here</p>
                    <h6  className="small-header">For the month of</h6>
                    
					
							
								<form className="form-inline">
									<div className="stepper-widget">
										<div className="">
                                        <select className="form-controls header-space "  value={this.state.Mmonth}  onChange={this.handleChange}  >
                                        <option value={this.state.current==='1' ? ''  : '1'} selected >January</option>
                                            <option value={this.state.current==='2' ? ''  : '2'} selected >February</option>
                                            <option value={this.state.current==='3' ? ''  : '3'} selected >March</option>
                                            <option value={this.state.current==='4' ? ''  : '4'} selected >April</option>
                                            <option value={this.state.current==='5' ? ''  : '5'} selected >May</option>
                                            <option value={this.state.current==='6' ? ''  : '6'} selected >June</option>
                                            <option value={this.state.current==='7' ? ''  : '7'} selected >July</option>
                                            <option value={this.state.current==='8' ? ''  : '8'} selected >August</option>
                                            <option value={this.state.current==='9' ? ''  : '9'} selected >September</option>
                                            <option value={this.state.current==='10' ? ''  : '10'} selected >October</option>
                                            <option value={this.state.current==='11' ? ''  : '11'} selected >November</option>
                                            <option value={this.state.current==='12' ? ''  : '12'} selected >December</option>
										    </select>
									    </div>
							        </div>
								</form>

                                   <div className=" bottom-space bottom-line ">
                                            <span className="float-right ">{/*{itm.debit ? -prc : +prc}*/}</span>
                                           
                        
                                              <h6 className="opacity-header">{/*<Moment format="DD MMMM yyyy" withTitle>{itm.posting_date}</Moment>*/}</h6>
                                                  <h6 className="purchase ">Purchase </h6>
                                                  <h6 className="Delivered ">Transaction successful</h6>
                                          </div>		
                
                </div>
            </div>
        </div>
    </div>
    }
}

export default Wallettrans;